import { useTranslation } from 'react-i18next';

const STYLES = {
  scheduled: 'bg-[#fef9e7] text-[#b59500]',
  active: 'bg-[#e8faf2] text-[#059669]',
  ended: 'bg-[rgba(250,63,88,0.15)] text-[#C81E3A]'
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-[11px] font-semibold ${STYLES[status] || STYLES.ended}`}>
      {t(`subscription.admin.campaigns.status.${status}`)}
    </span>
  );
};

export default StatusBadge;
